import api from './api';

const notificationService = {
  /**
   * Get notifications for the current user
   */
  getNotifications: async (unreadOnly = false, limit = 50, offset = 0) => {
    const response = await api.get('/notifications', {
      params: { unread_only: unreadOnly, limit, offset }
    });
    return response.data;
  },

  /**
   * Get unread notification count
   */
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data.unread_count;
  },

  /**
   * Mark a notification as read
   */
  markAsRead: async (notificationId) => {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  /**
   * Get mentions for the current user
   */
  getMentions: async (unreadOnly = false, limit = 50, offset = 0) => {
    const response = await api.get('/notifications/mentions', {
      params: { unread_only: unreadOnly, limit, offset }
    });
    return response.data;
  },

  /**
   * Start polling for new notifications
   * Returns a function to stop polling
   */
  startPolling: (callback, interval = 30000) => {
    let lastCount = null;

    const poll = async () => {
      try {
        const count = await notificationService.getUnreadCount();

        // Only call callback if count changed (new notifications)
        if (lastCount !== null && count > lastCount) {
          callback(count);
        }

        lastCount = count;
      } catch (error) {
        console.error('Error polling notifications:', error);
      }
    };

    // Initial poll
    poll();

    // Start interval
    const intervalId = setInterval(poll, interval);

    // Return stop function
    return () => clearInterval(intervalId);
  }
};

export default notificationService;
